import { Temporal } from '@imago/api-client'

export type Zoned<T> =
	T extends Temporal.Instant ? Temporal.ZonedDateTime :
	T extends Temporal.Duration ? T :
	T extends string ? T :
	{[Property in keyof T]: Zoned<T[Property]>}
